import type { CardProps } from '@iheartjane/reefer';
import { Card } from '@iheartjane/reefer';
import type { PropsWithChildren } from 'react';

export const MenuRowCard = ({
  children,
  ...props
}: PropsWithChildren<CardProps>) => (
  <Card width="100%" border="grays-light" {...props}>
    <Card.Content p={40}>{children}</Card.Content>
  </Card>
);
